import { render } from "./swap.vue?vue&type=template&id=47c51fa7"
import script from "./swap.vue?vue&type=script&lang=js"
export * from "./swap.vue?vue&type=script&lang=js"

import "./swap.vue?vue&type=style&index=0&id=47c51fa7&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__